import { render, staticRenderFns } from "./wheel2.vue?vue&type=template&id=5c515aac&scoped=true"
import script from "./wheel2.vue?vue&type=script&lang=js"
export * from "./wheel2.vue?vue&type=script&lang=js"
import style0 from "./wheel2.vue?vue&type=style&index=0&id=5c515aac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c515aac",
  null
  
)

export default component.exports